<template>
  <DialogRoot v-model:open="dialogOpen" @update:open="handleCloseBookServiceModal">
    <DialogPortal>
      <Transition enter-active-class="backdrop-enter" leave-active-class="backdrop-leave">
        <DialogOverlay v-if="dialogOpen" class="modal-backdrop" />
      </Transition>

      <Transition enter-active-class="modal-enter" leave-active-class="modal-leave">
        <DialogContent v-if="dialogOpen" class="modal-content">
          <DialogTitle as="div" class="mb-6 lg:mb-10 flex justify-between items-start">
            <h4 class="">{{ t('components.bookServiceModal.title') }}</h4>

            <DialogClose asChild class="cursor-pointer size-6 min-w-6 mt-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="text-accent"
              >
                <path
                  d="M16.192 6.34424L11.949 10.5862L7.70697 6.34424L6.29297 7.75824L10.535 12.0002L6.29297 16.2422L7.70697 17.6562L11.949 13.4142L16.192 17.6562L17.606 16.2422L13.364 12.0002L17.606 7.75824L16.192 6.34424Z"
                  fill="currentColor"
                />
              </svg>
            </DialogClose>
          </DialogTitle>

          <DialogDescription class="sr-only">
            {{ t('components.bookServiceModal.description') }}
          </DialogDescription>

          <iframe
            src="https://calendly.com/embed-demo-sales/demo?embed_domain=www.calendly-embed.com&amp;embed_type=PopupText&amp;hide_gdpr_banner=1"
            width="100%"
            height="1027px"
            frameborder="0"
            title="Select a Date &amp; Time - Calendly"
          ></iframe>
        </DialogContent>
      </Transition>
    </DialogPortal>
  </DialogRoot>
</template>

<script setup lang="ts">
  // import { Field, Form } from 'vee-validate';
  // import { z } from 'zod';
  // import { toTypedSchema } from '@vee-validate/zod';
  import {
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogOverlay,
    DialogPortal,
    DialogRoot,
    DialogTitle,
  } from 'reka-ui';

  // const isError = ref(false);
  // const isSuccess = ref(false);

  const { lockScroll, unlockScroll } = useScrollLock();
  const eventBus = useEventBus();

  const handleOpenBookServiceModal = () => {
    dialogOpen.value = true;
    lockScroll();
  };

  const handleCloseBookServiceModal = (v: boolean) => {
    if (!v) {
      dialogOpen.value = false;
      unlockScroll();
    }
  };

  eventBus.on('open-book-service-modal', handleOpenBookServiceModal);

  const { t } = useI18n();

  // Create a computed property for the open state that can be used with v-model
  const dialogOpen = ref(false);

  // const addToCalendar = () => {
  //   const formatDate = (date: Date) => {
  //     return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  //   };

  //   const startDate = new Date(props.event.startDate);
  //   const endDate = new Date(props.event.endDate);

  //   // Build location string
  //   const locationParts = [props.event.venue];
  //   if (props.event.address) locationParts.push(props.event.address);
  //   if (props.event.city) locationParts.push(props.event.city);
  //   const location = locationParts.join(', ');

  //   // Create ICS content
  //   const icsContent = [
  //     'BEGIN:VCALENDAR',
  //     'VERSION:2.0',
  //     'PRODID:-//Herbert Seidl//Event Calendar//EN',
  //     'CALSCALE:GREGORIAN',
  //     'METHOD:PUBLISH',
  //     'BEGIN:VEVENT',
  //     `UID:${props.event.documentId}@herbertseidl.at`,
  //     `DTSTAMP:${formatDate(new Date())}`,
  //     `DTSTART:${formatDate(startDate)}`,
  //     `DTEND:${formatDate(endDate)}`,
  //     `SUMMARY:${props.event.title.replace(/\n/g, '\\n')}`,
  //     `LOCATION:${location.replace(/\n/g, '\\n')}`,
  //     ...(props.event.description
  //       ? [`DESCRIPTION:${JSON.stringify(props.event.description).replace(/\n/g, '\\n')}`]
  //       : []),
  //     'STATUS:CONFIRMED',
  //     'SEQUENCE:0',
  //     'END:VEVENT',
  //     'END:VCALENDAR',
  //   ].join('\r\n');

  //   // Create and download the file
  //   const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  //   const url = URL.createObjectURL(blob);
  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.download = `${props.event.title.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.ics`;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  //   URL.revokeObjectURL(url);
  // };
</script>
